import AuthPortalService from "./services";

export const ezcalePortalAuth = async () => {
  try {
    const categoryService = new AuthPortalService();
    return categoryService.authPortal();
  } catch (error) {
    throw error;
  }
};